import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';
import './Landing.css';

// Client login step: the user types their practice name (e.g. "practice1").
// We look it up in omniMain.tenants via the backend and, on a match, redirect
// to that practice's own login page.
const API_URL = window.OMNIPRAC_CONFIG?.API_URL ?? 'http://localhost:5100/api';

const Practice = () => {
  const [practice, setPractice] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const findPractice = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    const name = practice.trim();
    if (!name) {
      setError('Please enter your practice name.');
      return;
    }

    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/users/check-practice/${encodeURIComponent(name)}`);
      if (res.data?.matches && res.data?.url) {
        setSuccess('Practice found — redirecting you to your login page…');
        window.location.href = res.data.url.replace(/\/$/, '') + '/login';
      } else {
        setError(res.data?.err || 'Practice not found. Please check the name and try again.');
      }
    } catch (err) {
      setError('Could not look up that practice: ' + (err.response?.data?.err || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="op-login-wrap">
      <div className="op-login-card">
        <Logo className="op-login-logo" />
        <h1>Client Login</h1>
        <p className="op-login-sub">Enter your practice name to continue.</p>

        <form onSubmit={findPractice}>
          <div className="op-field">
            <label htmlFor="practice">Practice name</label>
            <input
              id="practice"
              type="text"
              value={practice}
              onChange={(e) => setPractice(e.target.value)}
              placeholder="e.g. practice1"
              autoFocus
            />
          </div>

          {error && <div className="op-form-msg err">{error}</div>}
          {success && <div className="op-form-msg ok">{success}</div>}

          <button type="submit" className="op-btn op-btn-primary op-btn-lg" disabled={loading}>
            {loading ? 'Checking…' : 'Continue'}
          </button>
        </form>

        <div className="op-login-back">
          <Link to="/">&larr; Back to omniprac.com</Link>
        </div>
      </div>
    </div>
  );
};

export default Practice;
